module.exports = __webpack_public_path__ + "img/loading.0352de78.svg";